import request from './client';

export function login(email, password) {
  return request({
    method: 'POST',
    url: '/api/v1/login',
    data: {username: email, password: password},
    responseType: 'json'
  });
}

export function logout() {
  return request({
    method: 'GET',
    url: '/api/v1/logout',
    responseType: 'json'
  });
}


// WEBPACK FOOTER //
// ./src/gateways/authentication.js